var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { class: _vm.$style.style }, [
    _c("div", { staticClass: "header-view" }, [
      _c("div", { staticClass: "img-view" }, [
        _c("div", { staticClass: "square" }, [
          _c("div", { staticClass: "headerview520" }, [
            _c("img", {
              staticClass: "imagev",
              attrs: {
                src: _vm.imgSrc
                  ? _vm.imgSrc
                  : "https://res.wx.qq.com/wxopenres/htmledition/images/spacer32f740.gif"
              }
            })
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "circle" }, [
          _c("div", { staticClass: "headerview520" }, [
            _c("img", {
              staticClass: "imagev",
              attrs: {
                src: _vm.imgSrc
                  ? _vm.imgSrc
                  : "https://res.wx.qq.com/wxopenres/htmledition/images/spacer32f740.gif"
              }
            })
          ])
        ])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }